// extracted by mini-css-extract-plugin
export var cardTitle = "_iv-1";
export var commentBubble = "_iv-e";
export var commentForm = "_iv-a";
export var commentInput = "_iv-b";
export var commentLabel = "_iv-d";
export var commentPrompt = "_iv-9";
export var csatCard = "_iv-0";
export var feedbackSection = "_iv-7";
export var starDisabled = "_iv-6";
export var starEmpty = "_iv-5";
export var starFilled = "_iv-4";
export var starWrapper = "_iv-3";
export var starsContainer = "_iv-2";
export var submittedComment = "_iv-c";
export var thankYouText = "_iv-8";